module.exports = __webpack_public_path__ + "static/assets/0c66518b316506e014e08ca383be924e.svg";